export class PetReferHistModel {
    refer_sequence: number
    pet_no: number
    by_refer_doctor: string
    by_refer_hospital: string
    by_refer_date: string
    to_refer_doctor: string
    to_refer_hospital: string
    to_refer_date: string
    date_added: string
    done_by: string

    constructor(
        refer_sequence: number,
        pet_no: number,
        by_refer_doctor: string,
        by_refer_hospital: string,
        by_refer_date: string,
        to_refer_doctor: string,
        to_refer_hospital: string,
        to_refer_date: string,
        date_added: string,
        done_by: string
    ) {
        this.refer_sequence = refer_sequence
        this.pet_no = pet_no
        this.by_refer_doctor = by_refer_doctor
        this.by_refer_hospital = by_refer_hospital
        this.by_refer_date = by_refer_date
        this.to_refer_doctor = to_refer_doctor
        this.to_refer_hospital = to_refer_hospital
        this.to_refer_date = to_refer_date
        this.date_added = date_added
        this.done_by = done_by
    }
}
